import React from 'react';
import IconProps from '../interface/IconProps';

const SVG = ({
  style = {},
  fill = '#C0C0C0',
  width = 200,
  height = 200,
  className = '',
  viewBox = '0 0 1024 1024',
}: IconProps) => (
  <svg
    className={`svg-icon ${className || ''}`}
    style={style}
    viewBox={viewBox}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
  >
    <path
      d="M1014.633314 504L573.033314 62.628571l-29.6-29.6a36 36 0 0 0-50.742857 0L21.490457 504a73.028571 73.028571 0 0 0-21.485714 52.571429c0.457143 40.228571 33.942857 72.342857 74.171428 72.342857h48.571429V1001.142857h790.628571V628.914286h49.6c19.542857 0 37.942857-7.657143 51.771429-21.485715a72.685714 72.685714 0 0 0 21.371429-51.771428c0-19.428571-7.657143-37.828571-21.485715-51.657143zM582.061886 918.857143H454.061886V685.714286h128v233.142857z m249.028571-372.228572V918.857143H655.204743V658.285714c0-25.257143-20.457143-45.714286-45.714286-45.714285H426.633314c-25.257143 0-45.714286 20.457143-45.714285 45.714285v260.571429H205.033314V546.628571h-109.714285l422.857142-422.514285 26.4 26.4L940.919029 546.628571h-109.828572z"
      fill={fill}
    ></path>
  </svg>
);

export default SVG;
